export const reportGenerationParams = (assetCode) => ({
  prefix: 'payouts',
  url: '/v2/console/report-balance/',
  types: [
    'csv',
    // 'pdf'
  ],
  additionalData: {asset_code: assetCode}
})
